module.exports = __webpack_public_path__ + "img/bg-3.1f7cb244.png";